import * as THREE from 'three';
import Object2D from '../core/Object2D';

export class ClosePath extends Object2D {
    public position: THREE.Vector2[] = [];

    constructor(points: number[][]) {
      super();
      this.type = 'ClosePath';

      for (let i = 0; i < points.length; i++) {
        const p1 = points[i];
        this.position.push(new THREE.Vector2(p1[0], p1[1]));
      }
    }
}
